import e from "./ghl-ui.es1234.js";
var t = e(Object.keys, Object);
const a = t;
export {
  a as default
};
